class ConfigurationFactory {

  constructor($log) {
    this.$log = $log

    this.appName = 'hazel'
    this.productName = 'sol'
    this.microserviceDomain = '.oseberg.io'

    const searchEndpoint = 'https://search.oseberg.io'
    const usersEndpoint = 'https://users.oseberg.io'
    const notifyEndpoint = 'https://notify.oseberg.io'
    const billingEndpoint = 'https://billing.oseberg.io'
    const attachmentEndpoint = 'https://data.oseberg.io/service/attachment'
    const detailsEndpoint = 'https://details.oseberg.io/production/monthly/:id'

    const occCaseEndpoint = 'http://imaging.occeweb.com/imaging/OAP.aspx?caseNUM='
    const occWellsEndpoint = 'http://imaging.occeweb.com/imaging/OGWellRecords.aspx?api='

    this.detailEndpoint = searchEndpoint
    this.alertEndpoint  = searchEndpoint
    this.searchEndpoint = searchEndpoint
    this.detailsEndpoint = detailsEndpoint

    this.drillingAttachmentKey = 'occ-drilling'
    this.appOrderAttachmentKey = 'occ-apporder'
    this.unitizationAttachmentKey = 'occ-unitization'
    this.drillingAttachmentEndpoint = `${attachmentEndpoint}/${this.drillingAttachmentKey}/`
    this.appOrderAttachmentEndpoint = `${attachmentEndpoint}/${this.appOrderAttachmentKey}/`
    this.unitizationAttachmentEndpoint = `${attachmentEndpoint}/${this.unitizationAttachmentKey}/`
    this.attachmentsEndpoint = attachmentEndpoint + 's'

    this.roleResourcePath = usersEndpoint + '/user/:userId/roles'
    this.billingResourcePath = usersEndpoint + '/user/:userId/billing'
    this.alertResourcePath = searchEndpoint + '/alerts/user/:userId'

    this.occCaseEndpoint = occCaseEndpoint
    this.occWellsEndpoint = occWellsEndpoint

    this.searchPageSize = 1000

    this.accountEndpoint = usersEndpoint
    this.contactEndpoint = notifyEndpoint

    this.billingEndpoint = billingEndpoint
    this.plansResourcePath = this.billingEndpoint + '/plans'
    this.subscriptionResourcePath = this.billingEndpoint + '/subscription'
    this.datasetsResourcePath = this.billingEndpoint + '/datasets'

    this.imageBasePath = '/images'
    this.resultsImagePath = this.imageBasePath + '/search-results'

    this.recordBasePath = '/record'
    this.recordResourcePath = this.detailEndpoint + this.recordBasePath + '/:recordId'
    this.recordSearchPath = this.searchEndpoint + this.recordBasePath

    this.registrationResourcePath = this.accountEndpoint + '/registration'
    this.userResourcePath = this.accountEndpoint + '/user'

    this.authenticationEndpoint = 'https://auth.oseberg.io'

    this.recurlyKey = 'sjc-vXE6jW6izlKy8D7CEQ2ImG'

    this.resetPasswordEndpoint = usersEndpoint + '/reset-password'
  }
}

ConfigurationFactory.$inject = ['$log']

export default ConfigurationFactory
